<template>
  <div class="wrap">
    <div class="database-table">
      <el-table
        :data="tableData"
        ref="multipleTable"
        tooltip-effect="dark"
        style="width: 100%"
        @filter-change="handleFilterChange"
        v-loading="loading"
      >
        <el-table-column
          :label="$t('bill.historyList.number')"
          prop="Description"
        ></el-table-column>
        <el-table-column
          :label="$t('bill.historyList.tNumber')"
          prop="order_sn"
        ></el-table-column>
        <el-table-column :label="$t('bill.historyList.date')" prop="Date"> </el-table-column>
        <el-table-column
          :label="$t('bill.historyList.type')"
          prop="data_src_text"
          column-key="Type"
          :filters="dataSrc"
        >
        </el-table-column>
        <el-table-column
          :label="$t('bill.historyList.TChannel')"
          prop="pay_type_name"
        ></el-table-column>
        <el-table-column :label="$t('bill.historyList.amount')"  prop="Amout">
          <template slot-scope="scope">
            <p class="green" v-if="scope.row.flow_type == 1">+{{ $store.state.currency }} {{ $util.convertCurrency(scope.row.Amout) }}</p>
            <p class="red" v-else>-{{ $store.state.currency }} {{ $util.convertCurrency(scope.row.Amout) }}</p>
          </template>
        </el-table-column>
        <el-table-column :label="$t('bill.historyList.balance')">
          <template slot-scope="scope">
            <p v-if="scope.row.balance == '-'">{{ scope.row.balance }}</p>
            <p v-else>{{ $store.state.currency }} {{ $util.convertCurrency(scope.row.balance) }}</p>
          </template>
        </el-table-column>

      </el-table>
    </div>

    <div class="pagebox">
      <el-pagination
        background
        @current-change="handleCurrenChange"
        @size-change="handleSizeChange"
        :page-sizes="zizes"
        :current-page="page"
        :page-size="size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      keyword:'',
      loading:false,
      total:1,
      zizes:[10,20,30,50,100],
      size:10,
      page:1,
      Type:'',
      start:'',
      end:'',
      tableData: [],
      multipleSelection: [],
      dataSrc: [],
    };
  },
  mounted() {
    this.getDataSrc();
  },
  methods: {
    toggleSelection(rows) {
      if (rows) {
        rows.forEach((row) => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    async getDataSrc() {
      let {
        data: {code, message, data},
      } = await this.$http.get("/home/billing/getDataSrc", {});
      if (code === 0) {
        for (const i in data) {
          this.dataSrc.push({text: data[i], value: parseInt(i)});
        }
      } else {
        this.$message.error(message);
      }
    },
    //获取财务流水
    getList(){
      this.loading = true;
       let obj={
            page:this.page,
            pageNum:this.size,
            dataSrc:this.Type,
            start:this.start,
            end:this.end,
            keyword:this.keyword,
        }
        this.$http.post('/home/billing/getLogMoneyList', obj).then((res) => {
            this.loading = false;
            res = res.data.data;
            this.tableData = [];
            this.tableData = res.data;
            this.total = res.total;
            this.$forceUpdate()
        }).catch((err) => {
            this.$util.handleErr(err);
        })
    },
      handleCurrenChange:function(current){
          //页码更新
          this.page = current;
          //加载数据
          this.getList();
      },
      handleSizeChange(size){
          //数量更新
          this.size = size;
          //加载数据
          this.getList();
      },
      handleFilterChange(obj){
          this.$refs.multipleTable.clearSelection();
          this.Type = obj.hasOwnProperty("Type")
              ? obj.Type.join(",")
              : this.Type;
          this.getList();
      },
  },
    created() {
      this.getList();
    }
};
</script>
<style scoped lang="scss">
</style>




// WEBPACK FOOTER //
// src/pages/billing/TabHistory.vue